import React, { useState, useEffect } from 'react';

/**
 * Camcorder chrome for a found-footage theme: a blinking REC, a live
 * timestamp, and the tracking band that wanders across the top of a worn tape.
 *
 * Rendered by App for every theme and gated on `active`, which App reads from
 * the theme's `chrome.vhs` flag - so no theme id is hardcoded here or there.
 * The scanlines and vignette live in CSS on the shared .app-grain element; this
 * component exists only for the part CSS cannot do, which is tell the time.
 *
 * Decorative throughout: aria-hidden, no pointer events, and the clock stops
 * the moment it is inactive so it never ticks for a theme that is not using it.
 */
// "OCT 10 2026 23:47:10". en-US puts a comma after the day AND the year, so
// this has to strip all of them, not the first. hourCycle h23 rather than
// hour12:false, because some ICU builds render midnight as 24:00 under the
// latter and a camcorder never did.
const stamp = (d) => d
  .toLocaleString('en-US', {
    month: 'short', day: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  })
  .toUpperCase()
  .replace(/,/g, '');

const VhsOverlay = ({ active = false }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!active) return undefined;
    setNow(new Date());
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, [active]);

  if (!active) return null;

  return (
    <div className="vhs-hud" aria-hidden="true">
      <span className="vhs-rec">
        <span className="vhs-rec-dot" /> REC
      </span>
      <span className="vhs-stamp">{stamp(now)}</span>
      <div className="vhs-tracking" />
    </div>
  );
};

export default VhsOverlay;
